export default __webpack_public_path__ + "static/media/snow.08303cad.svg";